{
  "familyId": "GELD-TERUGREKENEN",
  "questions": [
    {
      "id": "GELD-TERUGREKENEN-001",
      "familyId": "GELD-TERUGREKENEN",
      "module": "Geld",
      "tier": 16,
      "levelCode": "E8+",
      "group": 8,
      "skill": "geld_toegepast",
      "subSkill": "geld_terugrekenen",
      "questionType": "multiple_choice",
      "question": "Een artikel kost na 20% korting €48. Wat was de oorspronkelijke prijs?",
      "options": ["€60", "€57,60", "€38,40", "€68"],
      "correctAnswer": 0,
      "conceptId": "reverse_discount_20pct",
      "variantIndex": 1,
      "citoDifficulty": 0.45,
      "citoDiscrimination": 0.68,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Terugrekenen bij korting",
            "content": "Na 20% korting is de prijs 80% van het origineel (100% − 20% = 80%). Origineel = kortingsprijs ÷ 0,80. Hier: €48 ÷ 0,80 = €60.",
            "icon": "lightbulb"
          }
        }
      ],
      "feedback": {
        "explanationText": "Na 20% korting is de prijs 80% van de originele prijs (100% − 20% = 80%). Terugrekenen: origineel = €48 ÷ 0,80 = €60.",
        "solutionSteps": [
          "Na 20% korting betaal je 80% van het origineel (100% − 20% = 80%)",
          "Origineel = kortingsprijs ÷ 0,80",
          "€48 ÷ 0,80 = €60",
          "Controleer: 20% van €60 = €12, €60 − €12 = €48 ✓"
        ],
        "distractorExplanations": {
          "0": "Goed! €48 is 80% van het origineel. €48 ÷ 0,80 = €60.",
          "1": "€57,60 klopt niet. Je hebt 20% van €48 opgeteld, maar de korting ging af van het oude bedrag. De kortingsprijs is 80% van het origineel: €48 ÷ 0,80 = €60.",
          "2": "€38,40 klopt niet. Je hebt de korting nog een keer van de €48 afgehaald. De prijs na korting is al €48. Terugrekenen: €48 ÷ 0,80 = €60.",
          "3": "€68 klopt niet. Je hebt simpelweg €20 opgeteld. Je moet rekenen met percentages: €48 ÷ 0,80 = €60."
        }
      }
    },
    {
      "id": "GELD-TERUGREKENEN-002",
      "familyId": "GELD-TERUGREKENEN",
      "module": "Geld",
      "tier": 16,
      "levelCode": "E8+",
      "group": 8,
      "skill": "geld_toegepast",
      "subSkill": "geld_terugrekenen",
      "questionType": "multiple_choice",
      "question": "Een prijs is met 10% verhoogd naar €132. Wat was de oorspronkelijke prijs?",
      "options": ["€120", "€145,20", "€118,80", "€122"],
      "correctAnswer": 0,
      "conceptId": "reverse_increase_10pct",
      "variantIndex": 2,
      "citoDifficulty": 0.43,
      "citoDiscrimination": 0.69,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Terugrekenen bij verhoging",
            "content": "Na 10% verhoging is de prijs 110% van het origineel (100% + 10% = 110%). Origineel = verhoogde prijs ÷ 1,10. Hier: €132 ÷ 1,10 = €120.",
            "icon": "lightbulb"
          }
        }
      ],
      "feedback": {
        "explanationText": "Na 10% verhoging is de prijs 110% van de originele prijs (100% + 10% = 110%). Terugrekenen: origineel = €132 ÷ 1,10 = €120.",
        "solutionSteps": [
          "Na 10% verhoging betaal je 110% van het origineel (100% + 10% = 110%)",
          "Origineel = verhoogde prijs ÷ 1,10",
          "€132 ÷ 1,10 = €120",
          "Controleer: 10% van €120 = €12, €120 + €12 = €132 ✓"
        ],
        "distractorExplanations": {
          "0": "Goed! €132 is 110% van het origineel. €132 ÷ 1,10 = €120.",
          "1": "€145,20 klopt niet. Je hebt de nieuwe prijs nog een keer verhoogd. Je moet terugrekenen: €132 ÷ 1,10 = €120.",
          "2": "€118,80 klopt niet. Je hebt 10% van de nieuwe prijs afgehaald, maar de verhoging was 10% van de oude prijs. €132 ÷ 1,10 = €120.",
          "3": "€122 klopt niet. Je hebt €10 eraf gehaald. Terugrekenen gaat via delen: €132 ÷ 1,10 = €120."
        }
      }
    },
    {
      "id": "GELD-TERUGREKENEN-003",
      "familyId": "GELD-TERUGREKENEN",
      "module": "Geld",
      "tier": 16,
      "levelCode": "E8+",
      "group": 8,
      "skill": "geld_toegepast",
      "subSkill": "geld_terugrekenen",
      "questionType": "multiple_choice",
      "question": "Een fiets kost na 25% korting €150. Wat was de oorspronkelijke prijs?",
      "options": ["€200", "€187,50", "€112,50", "€175"],
      "correctAnswer": 0,
      "conceptId": "reverse_discount_25pct",
      "variantIndex": 3,
      "citoDifficulty": 0.46,
      "citoDiscrimination": 0.67,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Terugrekenen bij 25% korting",
            "content": "Na 25% korting is de prijs 75% van het origineel. Origineel = €150 ÷ 0,75 = €200.",
            "icon": "lightbulb"
          }
        }
      ],
      "feedback": {
        "explanationText": "Na 25% korting is de prijs 75% van de originele prijs (100% − 25% = 75%). Terugrekenen: origineel = €150 ÷ 0,75 = €200.",
        "solutionSteps": [
          "Na 25% korting betaal je 75% van het origineel",
          "Origineel = €150 ÷ 0,75",
          "€150 ÷ 0,75 = €200",
          "Controleer: 25% van €200 = €50, €200 − €50 = €150 ✓"
        ],
        "distractorExplanations": {
          "0": "Goed! €150 is 75% van het origineel. €150 ÷ 0,75 = €200.",
          "1": "€187,50 klopt niet. Je hebt 25% van de kortingsprijs opgeteld. De korting was echter 25% van de oude prijs: €150 ÷ 0,75 = €200.",
          "2": "€112,50 klopt niet. Je hebt nogmaals korting berekend. Terugrekenen: €150 ÷ 0,75 = €200.",
          "3": "€175 klopt niet. Je hebt er simpelweg €25 bij opgeteld. Je moet delen door 0,75."
        }
      }
    },
    {
      "id": "GELD-TERUGREKENEN-004",
      "familyId": "GELD-TERUGREKENEN",
      "module": "Geld",
      "tier": 16,
      "levelCode": "E8+",
      "group": 8,
      "skill": "geld_toegepast",
      "subSkill": "geld_terugrekenen",
      "questionType": "multiple_choice",
      "question": "Een artikel kost na 10% korting €36. Wat was de oorspronkelijke prijs?",
      "options": ["€40", "€39,60", "€32,40", "€46"],
      "correctAnswer": 0,
      "conceptId": "reverse_discount_10pct",
      "variantIndex": 4,
      "citoDifficulty": 0.42,
      "citoDiscrimination": 0.70,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Terugrekenen bij 10% korting",
            "content": "Na 10% korting is de prijs 90% van het origineel. Origineel = €36 ÷ 0,90 = €40.",
            "icon": "lightbulb"
          }
        }
      ],
      "feedback": {
        "explanationText": "Na 10% korting is de prijs 90% van de originele prijs. Terugrekenen: origineel = €36 ÷ 0,90 = €40.",
        "solutionSteps": [
          "Na 10% korting betaal je 90% van het origineel",
          "€36 ÷ 0,90 = €40",
          "Controleer: 10% van €40 = €4, €40 − €4 = €36 ✓"
        ],
        "distractorExplanations": {
          "0": "Goed! €36 is 90% van het origineel. €36 ÷ 0,90 = €40.",
          "1": "€39,60 klopt niet. Je hebt 10% van de nieuwe prijs opgeteld. €36 ÷ 0,90 = €40.",
          "2": "€32,40 klopt niet. Je hebt nogmaals 10% korting berekend. €36 ÷ 0,90 = €40.",
          "3": "€46 klopt niet. Je hebt €10 opgeteld."
        }
      }
    },
    {
      "id": "GELD-TERUGREKENEN-005",
      "familyId": "GELD-TERUGREKENEN",
      "module": "Geld",
      "tier": 16,
      "levelCode": "E8+",
      "group": 8,
      "skill": "geld_toegepast",
      "subSkill": "geld_terugrekenen",
      "questionType": "multiple_choice",
      "question": "Een prijs is met 20% verhoogd naar €180. Wat was de oorspronkelijke prijs?",
      "options": ["€150", "€216", "€144", "€160"],
      "correctAnswer": 0,
      "conceptId": "reverse_increase_20pct",
      "variantIndex": 5,
      "citoDifficulty": 0.44,
      "citoDiscrimination": 0.68,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Terugrekenen bij 20% verhoging",
            "content": "Na 20% verhoging is de prijs 120% van het origineel. Origineel = €180 ÷ 1,20 = €150.",
            "icon": "lightbulb"
          }
        }
      ],
      "feedback": {
        "explanationText": "Na 20% verhoging is de prijs 120% van de originele prijs. Terugrekenen: origineel = €180 ÷ 1,20 = €150.",
        "solutionSteps": [
          "120% = €180",
          "1% = €180 ÷ 120 = €1,50",
          "100% = €1,50 × 100 = €150",
          "Controleer: 20% van €150 = €30, €150 + €30 = €180 ✓"
        ],
        "distractorExplanations": {
          "0": "Goed! €180 ÷ 1,20 = €150.",
          "1": "€216 klopt niet. Je hebt de verhoogde prijs weer met 20% verhoogd. Je moet terug naar de oude prijs.",
          "2": "€144 klopt niet. Je hebt 20% van €180 afgehaald, maar de verhoging was 20% van het oude bedrag.",
          "3": "€160 klopt niet. Je hebt er €20 afgehaald. Gebruik de deelsom."
        }
      }
    },
    {
      "id": "GELD-TERUGREKENEN-006",
      "familyId": "GELD-TERUGREKENEN",
      "module": "Geld",
      "tier": 16,
      "levelCode": "E8+",
      "group": 8,
      "skill": "geld_toegepast",
      "subSkill": "geld_terugrekenen",
      "questionType": "multiple_choice",
      "question": "Een jas kost na 30% korting €105. Wat was de oorspronkelijke prijs?",
      "options": ["€150", "€136,50", "€73,50", "€135"],
      "correctAnswer": 0,
      "conceptId": "reverse_discount_30pct",
      "variantIndex": 6,
      "citoDifficulty": 0.47,
      "citoDiscrimination": 0.67,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Terugrekenen bij 30% korting",
            "content": "Na 30% korting is de prijs 70% van het origineel. Origineel = €105 ÷ 0,70 = €150.",
            "icon": "lightbulb"
          }
        }
      ],
      "feedback": {
        "explanationText": "De prijs na korting (€105) is 70% van de oude prijs. Terugrekenen: €105 ÷ 0,70 = €150.",
        "solutionSteps": [
          "70% = €105",
          "10% = €15",
          "100% = €150",
          "Controleer: 30% van €150 = €45. €150 - €45 = €105 ✓"
        ],
        "distractorExplanations": {
          "0": "Goed! €105 ÷ 0,70 = €150.",
          "1": "€136,50 klopt niet. Je hebt 30% bij de nieuwe prijs opgeteld.",
          "2": "€73,50 klopt niet. Je hebt nogmaals 30% korting berekend.",
          "3": "€135 klopt niet. Je hebt €30 opgeteld."
        }
      }
    },
    {
      "id": "GELD-TERUGREKENEN-007",
      "familyId": "GELD-TERUGREKENEN",
      "module": "Geld",
      "tier": 16,
      "levelCode": "E8+",
      "group": 8,
      "skill": "geld_toegepast",
      "subSkill": "geld_terugrekenen",
      "questionType": "multiple_choice",
      "question": "Een product kost na 15% korting €68. Wat was de oorspronkelijke prijs?",
      "options": ["€80", "€78,20", "€57,80", "€83"],
      "correctAnswer": 0,
      "conceptId": "reverse_discount_15pct",
      "variantIndex": 7,
      "citoDifficulty": 0.46,
      "citoDiscrimination": 0.68,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Terugrekenen bij 15% korting",
            "content": "Na 15% korting is de prijs 85% van het origineel. Origineel = €68 ÷ 0,85 = €80.",
            "icon": "lightbulb"
          }
        }
      ],
      "feedback": {
        "explanationText": "De prijs na korting (€68) is 85% van de oude prijs. Terugrekenen: €68 ÷ 0,85 = €80.",
        "solutionSteps": [
          "85% = €68",
          "1% = €68 ÷ 85 = €0,80",
          "100% = €80",
          "Controleer: 15% van €80 = €12. €80 - €12 = €68 ✓"
        ],
        "distractorExplanations": {
          "0": "Goed! €68 ÷ 0,85 = €80.",
          "1": "€78,20 klopt niet. Je hebt 15% bij de nieuwe prijs opgeteld.",
          "2": "€57,80 klopt niet. Je hebt nogmaals 15% korting berekend.",
          "3": "€83 klopt niet. Je hebt er simpelweg €15 bij opgeteld."
        }
      }
    },
    {
      "id": "GELD-TERUGREKENEN-008",
      "familyId": "GELD-TERUGREKENEN",
      "module": "Geld",
      "tier": 16,
      "levelCode": "E8+",
      "group": 8,
      "skill": "geld_toegepast",
      "subSkill": "geld_terugrekenen",
      "questionType": "multiple_choice",
      "question": "Een prijs is met 25% verhoogd naar €45. Wat was de oorspronkelijke prijs?",
      "options": ["€36", "€56,25", "€33,75", "€20"],
      "correctAnswer": 0,
      "conceptId": "reverse_increase_25pct",
      "variantIndex": 8,
      "citoDifficulty": 0.48,
      "citoDiscrimination": 0.66,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Terugrekenen bij 25% verhoging",
            "content": "Na 25% verhoging is de prijs 125% van het origineel. Origineel = €45 ÷ 1,25 = €36.",
            "icon": "lightbulb"
          }
        }
      ],
      "feedback": {
        "explanationText": "Na 25% verhoging is de prijs 125% van de oude prijs. Terugrekenen: €45 ÷ 1,25 = €36.",
        "solutionSteps": [
          "125% = €45",
          "1% = €45 ÷ 125 = €0,36",
          "100% = €36",
          "Controleer: 25% van €36 = €9. €36 + €9 = €45 ✓"
        ],
        "distractorExplanations": {
          "0": "Goed! €45 ÷ 1,25 = €36.",
          "1": "€56,25 klopt niet. Je hebt de verhoogde prijs weer met 25% verhoogd.",
          "2": "€33,75 klopt niet. Je hebt 25% van de nieuwe prijs afgehaald.",
          "3": "€20 klopt niet. Dit bedrag is veel te laag."
        }
      }
    },
    {
      "id": "GELD-TERUGREKENEN-009",
      "familyId": "GELD-TERUGREKENEN",
      "module": "Geld",
      "tier": 16,
      "levelCode": "E8+",
      "group": 8,
      "skill": "geld_toegepast",
      "subSkill": "geld_terugrekenen",
      "questionType": "multiple_choice",
      "question": "Een laptop kost na 20% korting €720. Wat was de oorspronkelijke prijs?",
      "options": ["€900", "€864", "€576", "€740"],
      "correctAnswer": 0,
      "conceptId": "reverse_discount_20pct_large",
      "variantIndex": 9,
      "citoDifficulty": 0.44,
      "citoDiscrimination": 0.69,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Terugrekenen bij 20% korting",
            "content": "Na 20% korting is de prijs 80% van het origineel. Origineel = €720 ÷ 0,80 = €900.",
            "icon": "lightbulb"
          }
        }
      ],
      "feedback": {
        "explanationText": "Na 20% korting is de prijs 80%. Terugrekenen: €720 ÷ 0,80 = €900.",
        "solutionSteps": [
          "80% = €720",
          "10% = €90",
          "100% = €900",
          "Controleer: 20% van €900 = €180. €900 - €180 = €720 ✓"
        ],
        "distractorExplanations": {
          "0": "Goed! €720 is 80% van het origineel. €720 ÷ 0,80 = €900.",
          "1": "€864 klopt niet. Je hebt 20% van €720 erbij opgeteld.",
          "2": "€576 klopt niet. Je hebt nogmaals 20% korting berekend.",
          "3": "€740 klopt niet. Je hebt slechts €20 opgeteld."
        }
      }
    },
    {
      "id": "GELD-TERUGREKENEN-010",
      "familyId": "GELD-TERUGREKENEN",
      "module": "Geld",
      "tier": 16,
      "levelCode": "E8+",
      "group": 8,
      "skill": "geld_toegepast",
      "subSkill": "geld_terugrekenen",
      "questionType": "multiple_choice",
      "question": "Een dienst kost na 10% verhoging €264. Wat was de oorspronkelijke prijs?",
      "options": ["€240", "€290,40", "€237,60", "€254"],
      "correctAnswer": 0,
      "conceptId": "reverse_increase_10pct_large",
      "variantIndex": 10,
      "citoDifficulty": 0.43,
      "citoDiscrimination": 0.69,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Terugrekenen bij 10% verhoging",
            "content": "Na 10% verhoging is de prijs 110% van het origineel. Origineel = €264 ÷ 1,10 = €240.",
            "icon": "lightbulb"
          }
        }
      ],
      "feedback": {
        "explanationText": "De prijs is nu 110%. Terugrekenen: €264 ÷ 1,10 = €240.",
        "solutionSteps": [
          "110% = €264",
          "10% = €264 ÷ 11 = €24",
          "100% = €240",
          "Controleer: 10% van €240 = €24. €240 + €24 = €264 ✓"
        ],
        "distractorExplanations": {
          "0": "Goed! €264 ÷ 1,10 = €240.",
          "1": "€290,40 klopt niet. Je hebt 10% bij de nieuwe prijs opgeteld.",
          "2": "€237,60 klopt niet. Je hebt 10% van de nieuwe prijs afgehaald.",
          "3": "€254 klopt niet. Je hebt €10 afgehaald."
        }
      }
    },
    {
      "id": "GELD-TERUGREKENEN-011",
      "familyId": "GELD-TERUGREKENEN",
      "module": "Geld",
      "tier": 16,
      "levelCode": "E8+",
      "group": 8,
      "skill": "geld_toegepast",
      "subSkill": "geld_terugrekenen",
      "questionType": "multiple_choice",
      "question": "Een artikel kost na 40% korting €120. Wat was de oorspronkelijke prijs?",
      "options": ["€200", "€168", "€72", "€160"],
      "correctAnswer": 0,
      "conceptId": "reverse_discount_40pct",
      "variantIndex": 11,
      "citoDifficulty": 0.48,
      "citoDiscrimination": 0.66,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Terugrekenen bij 40% korting",
            "content": "Na 40% korting is de prijs 60% van het origineel. Origineel = €120 ÷ 0,60 = €200.",
            "icon": "lightbulb"
          }
        }
      ],
      "feedback": {
        "explanationText": "Na 40% korting is de prijs nog 60%. Terugrekenen: €120 ÷ 0,60 = €200.",
        "solutionSteps": [
          "60% = €120",
          "1% = €2",
          "100% = €200",
          "Controleer: 40% van €200 = €80. €200 - €80 = €120 ✓"
        ],
        "distractorExplanations": {
          "0": "Goed! €120 ÷ 0,60 = €200.",
          "1": "€168 klopt niet. Je hebt 40% van €120 erbij opgeteld.",
          "2": "€72 klopt niet. Je hebt nogmaals 40% korting berekend.",
          "3": "€160 klopt niet. Je hebt er €40 bij opgeteld."
        }
      }
    },
    {
      "id": "GELD-TERUGREKENEN-012",
      "familyId": "GELD-TERUGREKENEN",
      "module": "Geld",
      "tier": 16,
      "levelCode": "E8+",
      "group": 8,
      "skill": "geld_toegepast",
      "subSkill": "geld_terugrekenen",
      "questionType": "multiple_choice",
      "question": "Een prijs is met 50% verhoogd naar €105. Wat was de oorspronkelijke prijs?",
      "options": ["€70", "€157,50", "€52,50", "€55"],
      "correctAnswer": 0,
      "conceptId": "reverse_increase_50pct",
      "variantIndex": 12,
      "citoDifficulty": 0.45,
      "citoDiscrimination": 0.68,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Terugrekenen bij 50% verhoging",
            "content": "Na 50% verhoging is de prijs 150% van het origineel. Origineel = €105 ÷ 1,50 = €70.",
            "icon": "lightbulb"
          }
        }
      ],
      "feedback": {
        "explanationText": "Na 50% verhoging is de prijs 150%. Terugrekenen: €105 ÷ 1,50 = €70.",
        "solutionSteps": [
          "150% = €105",
          "50% = €35",
          "100% = €70",
          "Controleer: 50% van €70 = €35. €70 + €35 = €105 ✓"
        ],
        "distractorExplanations": {
          "0": "Goed! €105 ÷ 1,50 = €70.",
          "1": "€157,50 klopt niet. Je hebt de nieuwe prijs weer met 50% verhoogd.",
          "2": "€52,50 klopt niet. Je hebt de helft van de nieuwe prijs genomen.",
          "3": "€55 klopt niet. Je hebt er €50 afgehaald."
        }
      }
    },
    {
      "id": "GELD-TERUGREKENEN-013",
      "familyId": "GELD-TERUGREKENEN",
      "module": "Geld",
      "tier": 16,
      "levelCode": "E8+",
      "group": 8,
      "skill": "geld_toegepast",
      "subSkill": "geld_terugrekenen",
      "questionType": "multiple_choice",
      "question": "Een factuur is inclusief 21% BTW €145,20. Wat was het bedrag exclusief BTW?",
      "options": ["€120", "€175,69", "€114,71", "€124,20"],
      "correctAnswer": 0,
      "conceptId": "reverse_increase_21pct_btw",
      "variantIndex": 13,
      "citoDifficulty": 0.52,
      "citoDiscrimination": 0.65,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Terugrekenen bij 21% BTW",
            "content": "Inclusief 21% BTW is de prijs 121% van het origineel. Origineel = €145,20 ÷ 1,21 = €120.",
            "icon": "lightbulb"
          }
        }
      ],
      "feedback": {
        "explanationText": "De prijs inclusief BTW (€145,20) is 121% van het bedrag zonder BTW. Terugrekenen: €145,20 ÷ 1,21 = €120.",
        "solutionSteps": [
          "121% = €145,20",
          "1% = €145,20 ÷ 121 = €1,20",
          "100% = €120",
          "Controleer: 21% van €120 = €25,20. €120 + €25,20 = €145,20 ✓"
        ],
        "distractorExplanations": {
          "0": "Goed! €145,20 ÷ 1,21 = €120.",
          "1": "€175,69 klopt niet. Je hebt de inclusief-prijs nogmaals met 21% verhoogd.",
          "2": "€114,71 klopt niet. Je hebt 21% van de inclusief-prijs afgetrokken, maar de BTW was 21% van het originele (lagere) bedrag.",
          "3": "€124,20 klopt niet. Je hebt er simpelweg €21 afgehaald."
        }
      }
    },
    {
      "id": "GELD-TERUGREKENEN-014",
      "familyId": "GELD-TERUGREKENEN",
      "module": "Geld",
      "tier": 16,
      "levelCode": "E8+",
      "group": 8,
      "skill": "geld_toegepast",
      "subSkill": "geld_terugrekenen",
      "questionType": "multiple_choice",
      "question": "Een smartwatch kost na 12% korting €220. Wat was de oorspronkelijke prijs?",
      "options": ["€250", "€246,40", "€193,60", "€232"],
      "correctAnswer": 0,
      "conceptId": "reverse_discount_12pct",
      "variantIndex": 14,
      "citoDifficulty": 0.50,
      "citoDiscrimination": 0.67,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Terugrekenen bij 12% korting",
            "content": "Na 12% korting is de prijs 88% van het origineel. Origineel = €220 ÷ 0,88 = €250.",
            "icon": "lightbulb"
          }
        }
      ],
      "feedback": {
        "explanationText": "Na 12% korting is de prijs 88%. Terugrekenen: €220 ÷ 0,88 = €250.",
        "solutionSteps": [
          "88% = €220",
          "1% = €220 ÷ 88 = €2,50",
          "100% = €250",
          "Controleer: 12% van €250 = €30. €250 - €30 = €220 ✓"
        ],
        "distractorExplanations": {
          "0": "Goed! €220 ÷ 0,88 = €250.",
          "1": "€246,40 klopt niet. Je hebt 12% bij de nieuwe prijs opgeteld. Je moet de oude prijs berekenen met een deelsom.",
          "2": "€193,60 klopt niet. Je hebt nogmaals 12% korting berekend.",
          "3": "€232 klopt niet. Je hebt er €12 bij opgeteld."
        }
      }
    },
    {
      "id": "GELD-TERUGREKENEN-015",
      "familyId": "GELD-TERUGREKENEN",
      "module": "Geld",
      "tier": 16,
      "levelCode": "E8+",
      "group": 8,
      "skill": "geld_toegepast",
      "subSkill": "geld_terugrekenen",
      "questionType": "multiple_choice",
      "question": "Een boek kost inclusief 9% BTW €54,50. Wat is de prijs zonder BTW?",
      "options": ["€50", "€59,40", "€49,60", "€45,50"],
      "correctAnswer": 0,
      "conceptId": "reverse_increase_9pct_btw",
      "variantIndex": 15,
      "citoDifficulty": 0.49,
      "citoDiscrimination": 0.68,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Terugrekenen bij 9% BTW",
            "content": "Inclusief 9% BTW is de prijs 109% van het origineel. Origineel = €54,50 ÷ 1,09 = €50.",
            "icon": "lightbulb"
          }
        }
      ],
      "feedback": {
        "explanationText": "De prijs inclusief BTW is 109%. Terugrekenen: €54,50 ÷ 1,09 = €50.",
        "solutionSteps": [
          "109% = €54,50",
          "1% = €54,50 ÷ 109 = €0,50",
          "100% = €50",
          "Controleer: 9% van €50 = €4,50. €50 + €4,50 = €54,50 ✓"
        ],
        "distractorExplanations": {
          "0": "Goed! €54,50 ÷ 1,09 = €50.",
          "1": "€59,40 klopt niet. Je hebt de prijs inclusief BTW nogmaals met 9% verhoogd.",
          "2": "€49,60 klopt niet. Je hebt 9% van de inclusief-prijs afgetrokken. Je moet delen door 1,09.",
          "3": "€45,50 klopt niet. Je hebt simpelweg €9 van de prijs afgehaald."
        }
      }
    },
    {
      "id": "GELD-TERUGREKENEN-016",
      "familyId": "GELD-TERUGREKENEN",
      "module": "Geld",
      "tier": 16,
      "levelCode": "E8+",
      "group": 8,
      "skill": "geld_toegepast",
      "subSkill": "geld_terugrekenen",
      "questionType": "multiple_choice",
      "question": "Tijdens een actie met 21% korting betaal je voor een televisie €316. Wat was de oorspronkelijke prijs?",
      "options": ["€400", "€382,36", "€249,64", "€337"],
      "correctAnswer": 0,
      "conceptId": "reverse_discount_21pct",
      "variantIndex": 16,
      "citoDifficulty": 0.53,
      "citoDiscrimination": 0.64,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Terugrekenen bij 21% korting",
            "content": "Na 21% korting is de prijs 79% van het origineel. Origineel = €316 ÷ 0,79 = €400.",
            "icon": "lightbulb"
          }
        }
      ],
      "feedback": {
        "explanationText": "Na 21% korting is de prijs 79% (100% - 21%). Terugrekenen: €316 ÷ 0,79 = €400.",
        "solutionSteps": [
          "79% = €316",
          "1% = €316 ÷ 79 = €4",
          "100% = €400",
          "Controleer: 21% van €400 = €84. €400 - €84 = €316 ✓"
        ],
        "distractorExplanations": {
          "0": "Goed! €316 ÷ 0,79 = €400.",
          "1": "€382,36 klopt niet. Je hebt 21% van €316 berekend en dat erbij opgeteld. Gebruik de deelsom: delen door 0,79.",
          "2": "€249,64 klopt niet. Je hebt de korting nog een keer van de actieprijs gehaald.",
          "3": "€337 klopt niet. Je hebt simpelweg €21 opgeteld."
        }
      }
    },
    {
      "id": "GELD-TERUGREKENEN-017",
      "familyId": "GELD-TERUGREKENEN",
      "module": "Geld",
      "tier": 16,
      "levelCode": "E8+",
      "group": 8,
      "skill": "geld_toegepast",
      "subSkill": "geld_terugrekenen",
      "questionType": "fill_in",
      "question": "Een trui kost na 20% korting €56. Wat was de oorspronkelijke prijs? Typ je antwoord in euro's (bijv. 70).",
      "correctAnswer": "70",
      "data": {
        "acceptedAnswers": ["70", "€70", "70,00", "€70,00"],
        "placeholder": "oorspronkelijke prijs in €",
        "inputType": "number"
      },
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Terugrekenen bij korting",
            "content": "Na 20% korting is de prijs 80% van het origineel (100% − 20% = 80%). Origineel = kortingsprijs ÷ 0,80. Hier: €56 ÷ 0,80 = €70.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "reverse_discount_fill_in",
      "variantIndex": 17,
      "citoDifficulty": 0.50,
      "citoDiscrimination": 0.67,
      "feedback": {
        "explanationText": "Na 20% korting betaal je 80% van het origineel. Terugrekenen: €56 ÷ 0,80 = €70. Controleer: 20% van €70 = €14. €70 − €14 = €56 ✓",
        "solutionSteps": [
          "Na 20% korting betaal je 80% van het origineel",
          "Origineel = €56 ÷ 0,80",
          "€56 ÷ 0,80 = €70",
          "Controleer: 20% van €70 = €14. €70 − €14 = €56 ✓"
        ]
      }
    },
    {
      "id": "GELD-TERUGREKENEN-018",
      "familyId": "GELD-TERUGREKENEN",
      "module": "Geld",
      "tier": 16,
      "levelCode": "E8+",
      "group": 8,
      "skill": "geld_toegepast",
      "subSkill": "geld_terugrekenen",
      "questionType": "fill_in",
      "question": "Een abonnement is met 15% verhoogd naar €69. Wat was de oorspronkelijke prijs? Typ je antwoord in euro's (bijv. 60).",
      "correctAnswer": "60",
      "data": {
        "acceptedAnswers": ["60", "€60", "60,00", "€60,00"],
        "placeholder": "oorspronkelijke prijs in €",
        "inputType": "number"
      },
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Terugrekenen bij verhoging",
            "content": "Na 15% verhoging is de prijs 115% van het origineel. Origineel = €69 ÷ 1,15 = €60.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "reverse_increase_fill_in",
      "variantIndex": 18,
      "citoDifficulty": 0.52,
      "citoDiscrimination": 0.66,
      "feedback": {
        "explanationText": "Na 15% verhoging is de prijs 115% van het origineel. Terugrekenen: €69 ÷ 1,15 = €60. Controleer: 15% van €60 = €9. €60 + €9 = €69 ✓",
        "solutionSteps": [
          "Na 15% verhoging betaal je 115% van het origineel",
          "Origineel = €69 ÷ 1,15",
          "€69 ÷ 1,15 = €60",
          "Controleer: 15% van €60 = €9. €60 + €9 = €69 ✓"
        ]
      }
    }
  ]
}